export default "__VITE_ASSET__BDlAdDTI__"